import React from 'react';
import classNames from 'clsx';

import { StickyProps } from './Sticky.interfaces';
import { useStyles } from './Sticky.styles';
import isSafariOrIos from 'app/shared/helpers/isSafariOrIos';

export default function Sticky(props: StickyProps) {
  const classes = useStyles();

  const { className, children, id } = props;

  return (
    <div
      id={id}
      className={classNames(
        {
          // sticky disabled on Mobile iOS and in Safari desktop browser
          // because of buggy implementation of position: sticky
          [classes.sticky]: !isSafariOrIos(),
        },
        className
      )}
    >
      {children}
    </div>
  );
}
